import React from 'react';
import ReactTable from "react-table";
import classnames from 'classnames';
import { GridLoader } from 'react-spinners';

const tableConstants = {
    pageText: "",
    previousText: "< Previous",
    nextText: "Next >",
    defaultPageSize: 10,
    minRows: 3
};

const getLoadingComponent = (props) => {  
    return <div className={classnames("d-flex align-items-center justify-content-center", props.loading ? "-loading -active" : "")}>
      <GridLoader
        sizeunit={"px"}
        size={10}
        color={'#00BFFF'}
        className={"margin-left: 50%; width: 42px !important; font-size:0 !important; top: 30% !important"}
        loading={props.loading} />
    </div>
}

const Table = (props) => {
    // {defaultPageSize,minRows,tableData,columns,defaultSorted,className}
    return (
        <ReactTable {...tableConstants}
            {...props}
        // minRows={minRows ?minRows : tableConstants.minRows}
        // defaultPageSize={defaultPageSize ? defaultPageSize : tableConstants.defaultPageSize}
        // data={tableData}
        // columns={columns}
        // defaultSorted={defaultSorted}
        // className={className}
        LoadingComponent={getLoadingComponent}
        />
    )
}

export default Table
